import { createVanIconComponent } from "./van"

const OtherPay = createVanIconComponent("other-pay")
export default OtherPay
